import { reactive } from 'vue'
import { EditorStateNotFound } from 'client/errors'
import { useWorkspaceStore } from 'app/services/pinia/workspace-store'
import type { CreateAction } from 'app/services/action'

interface OpenHrefArgs {
  href: string
  sourceTopicId?: string
}

export const createOpenHrefAction: CreateAction<OpenHrefArgs, void> = function (service_ignored?: unknown) {
  return reactive({
    get isEnabled() {
      const editorState = useWorkspaceStore().editor
      const workbook = useWorkspaceStore().workbook
      return Boolean(workbook && editorState && editorState?.mapStatus === 'loaded')
    },
    get execute() {
      return async (args: OpenHrefArgs) => {
        if (!this.isEnabled) {
          return
        }
        const { href, sourceTopicId } = args

        const workbook = useWorkspaceStore().workbook
        if (!workbook) {
          throw new EditorStateNotFound()
        }

        //
        // Open Topic link
        //
        if (href.startsWith('xmind:#') && sourceTopicId) {
          const targetTopicId = href.replace('xmind:#', '')
          const targetTopicQuery = workbook.document.value.query({ id: targetTopicId })
          if (targetTopicQuery) {
            const sourceSheet = workbook.document.value.query({ id: sourceTopicId }).asTopic().ownerSheet
            const targetSheet = targetTopicQuery.asTopic().ownerSheet
            if (sourceSheet.id !== targetSheet.id) {
              workbook.workbookEditor.executeEditorAction({
                name: 'mutateEditor:switchSheet',
                inputValue: targetSheet.id,
              })
            }

            await new Promise(resolve => setTimeout(resolve, 10))
            workbook.workbookEditor.executeEditorAction({
              name: 'mutateEditor:unfoldTopicAncestors',
              payload: {
                topicId: [targetTopicId],
              },
            })

            await new Promise(resolve => setTimeout(resolve, 100))

            workbook.workbookEditor.executeMutationAction({
              name: 'mutate:selectTopics',
              payload: {
                topics: [targetTopicId],
                centerOn: true,
              },
            })
          }
          return
        }

        /**
         * open WPS source link
         */
        if (href.startsWith('source://')) {
          window.open(href)
          return
        }

        //
        // Open hyperlink
        //
        const hyperlink = href

        if (href.startsWith('file:') || href.startsWith('http:') || href.startsWith('https:')) {
          window.open(hyperlink)
        } else {
          window.location.href = hyperlink
        }
      }
    },
  })
}
